import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Layout from '@/views/layout/layout.vue'
import store from '@/store'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/home_yl',
    name: 'home_yl',
    component: Home
  },
  {
    path: '/content',
    name: 'index',
    component: Layout,
    children: [
      {
        path: '/news',
        name: 'news',
        component: () => import('@/views/news/index')
      },

      {
        path: '/connection',
        name: 'connection',
        component: () => import('@/views/connection/index')
      },
      {
        path: '/recruit',
        name: 'recruit',
        component: () => import('@/views/recruit/index')
      },
      {
        path: '/recruitMsg/:id',
        name: 'recruitMsg',
        component: () => import('@/views/recruit/detail.vue')
      },
      {
        path: '/about',
        name: 'about',
        component: () => import('@/views/about/index')
      },
      {
        path: '/culture',
        name: 'culture',
        component: () => import('@/views/culture/index')
      },
      {
        path: '/business',
        name: 'business',
        component: () => import('@/views/businessWork/index')
      },

      {
        path: '/news_yl',
        name: 'news_yl',
        component: () => import('@/views/news/index')
      },

      {
        path: '/connection_yl',
        name: 'connection_yl',
        component: () => import('@/views/connection/index')
      },
      {
        path: '/recruit_yl',
        name: 'recruit_yl',
        component: () => import('@/views/recruit/index')
      },
      {
        path: '/recruitMsg_yl/:id',
        name: 'recruitMsg_yl',
        component: () => import('@/views/recruit/detail.vue')
      },
      {
        path: '/about_yl',
        name: 'about_yl',
        component: () => import('@/views/about/index')
      },
      {
        path: '/culture_yl',
        name: 'culture_yl',
        component: () => import('@/views/culture/index')
      },
      {
        path: '/business_yl',
        name: 'business_yl',
        component: () => import('@/views/businessWork/index')
      }
    ]
  },
  {
    path: '/newsMsg',
    name: 'newsMsg',
    component: () => import('@/views/news/detail')
  },
  {
    path: '/newsMsg_yl',
    name: 'newsMsg_yl',
    component: () => import('@/views/news/detail')
  },
  {
    path: '*',
    component: () => import('@/views/error-page/404'),
    redirect: '/'
  }
]

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.onError(error => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    router.replace(targetPath)
  }
})

router.beforeEach((to, from, next) => {
  if (to.name.substr(to.name.length - 3, 3) == '_yl') {
    store.commit('setUrlStatus', true)
  } else {
    store.commit('setUrlStatus', false)
  }
  next()
})

export default router
